module.exports = __webpack_public_path__ + "media/images/flags/ML-66852363afe1d74ae9119f1391eb7c6c.svg";